var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#key_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#key_svg__b)",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M9.188 1.75A3.063 3.063 0 0 0 6.17 5.338c.074.43-.012.935-.373 1.296l-3.79 3.79a.88.88 0 0 0-.257.62v1.206h1.313v-.875c0-.242.195-.437.437-.437h.875v-.876c0-.241.196-.437.438-.437h1.13l1.423-1.422c.361-.361.866-.447 1.296-.373q.256.045.525.045a3.062 3.062 0 1 0 0-6.125M5.25 4.813a3.938 3.938 0 1 1 3.263 3.88c-.227-.04-.418.018-.528.128l-1.55 1.55a.44.44 0 0 1-.31.129H5.25v.875a.44.44 0 0 1-.437.438h-.875v.874a.44.44 0 0 1-.438.438H1.313a.44.44 0 0 1-.438-.437v-1.644c0-.465.184-.91.513-1.238l3.79-3.79c.111-.111.169-.302.13-.529a4 4 0 0 1-.058-.675m3.5-1.75c0-.242.196-.438.438-.438 1.208 0 2.187.98 2.187 2.188a.438.438 0 0 1-.875 0c0-.725-.588-1.313-1.312-1.313a.44.44 0 0 1-.438-.437",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "key_svg__b",
    x1: 7,
    x2: 7,
    y1: 0.875,
    y2: 13.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "key_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgKey;